export enum Cultures {
  PL = 'pl',
  EN = 'en',
  DE = 'de',
}
